const wms = [
    {
        path: '/wms',
        name: 'wms',
        component: () => import('@/views/wms/index.vue'),
    },
	{
	    path: '/wmsLogin',
	    name: 'wmsLogin',
	    component: () => import('@/views/wms/login.vue'),
	}
]
export default wms